import { render, staticRenderFns } from "./ExportationFrameWalkingChartPronationAngles.vue?vue&type=template&id=45887f50&scoped=true&"
import script from "./ExportationFrameWalkingChartPronationAngles.vue?vue&type=script&lang=js&"
export * from "./ExportationFrameWalkingChartPronationAngles.vue?vue&type=script&lang=js&"
import style0 from "./ExportationFrameWalkingChartPronationAngles.vue?vue&type=style&index=0&id=45887f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45887f50",
  null
  
)

export default component.exports